<script>
  import ChoiceInput from './choice-input.svelte';

  export let value;

  export let onChange = () => {};

  const options = [
    { value: 'start', icon: 'align-start-horizontal' },
    { value: 'center', icon: 'align-center-horizontal' },
    { value: 'end', icon: 'align-end-horizontal' }
  ];
</script>

<ChoiceInput {value} {options} {onChange} />
